export const modulationContractsCachekeys = {
  all: (queryParams = {}) => [
    'modulation_location_eligible_contracts',
    queryParams
  ]
}
